import { React, useState, useEffect, Fragment } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import moment from "moment";
import { Icon } from "@iconify/react";
import "./MessageList.css";
import ModalMedia from "./ModalMedia";
import Loader from "../Components/Loader";
import renderMessageFB from "../Helper/renderMessageFB";

import {
  getFacebookMessage,
  getFacebookMessageHistory,
} from "../Store/Actions/MetaAction";

function MessageListFB({ chatListID, sessionNo, setPagesID, FBID }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [getDate, setGetDate] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalMediaOpen, setIsModalMediaOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [selectedMediaType, setSelectedMediaType] = useState("");
  const [selectedMediaURL, setSelectedMediaURL] = useState("");
  const { updateChat, updateChatSingle } = useSelector((state) => state.chat);
  let scrollTimer = null;

  useEffect(() => {
    const renderDateFLoat = () => {
      const messageBox = document.getElementById(
        "messageListInfiniteScrollTarget"
      );
      let dateFloat = document.getElementsByClassName("DateFloat");
      if (dateFloat.length > 0) dateFloat = dateFloat[0];
      const scrollEvent = (box) => {
        dateFloat.style.top = "0vh";
        dateFloat.style.opacity = 1;

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(() => {
          dateFloat.style.top = "-2vh";
          dateFloat.style.opacity = 0;
        }, 2000);

        const dateLabels = document.querySelectorAll(".DateSeparator");
        let currentLabel = null;
        let boxR = box.getBoundingClientRect();

        dateLabels.forEach((dateLabel, idx, arr) => {
          let dlR = dateLabel.getBoundingClientRect();
          if (dlR.top > boxR.top) {
            currentLabel = idx >= dateLabels.length ? arr[idx] : arr[idx + 1];
          } else if (idx === 0) {
            currentLabel = arr[idx];
          }
        });

        if (currentLabel) {
          let el = currentLabel.getElementsByClassName("DateSeparatorVal");
          if (el && el.length > 0) setGetDate(el[0].innerText);
        }
      };

      messageBox?.removeEventListener("scroll", () => {
        scrollEvent(messageBox);
      });

      messageBox?.addEventListener("scroll", () => {
        scrollEvent(messageBox);
      });
    };

    renderDateFLoat();
  }, []);

  // Effect ran when selected chat is changed
  useEffect(() => {
    if (FBID) {
      getFacebookMessageHistory(chatListID, FBID)
        .then((response) => {
          if (response.status) {
            process.env.NODE_ENV === "development" &&
              console.log("message history: ", response.data);

            setMessages(response.data.chatmessage);
            setGetDate(response.data.chatmessage[0]?.CreatedTime);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      fetchMessageListFB(1, false, true, true);
    }
  }, [chatListID]);

  // Effect ran when a new chat comes
  // Doesn't run when used in chat history
  useEffect(() => {
    !FBID && fetchMessageListFB(1, false, true);
  }, [updateChat, updateChatSingle]);

  const fetchMessageListFB = (
    page,
    isNewMessage,
    isChatListIDChanged,
    isFirstLoad
  ) => {
    if (isFirstLoad) {
      setIsLoading(true);
    }

    getFacebookMessage(chatListID, page, isNewMessage, sessionNo)
      .then((response) => {
        if (response.status) {
          setPagesID(response.data.conversation[0].PagesID);

          // Stop fetching when all messages has been fetched
          if (messages.length >= response.data.total) {
            setHasMore(false);
            setIsLoading(false);
          }

          /* if (isNewMessage) {
            console.log("new");
            setMessages([...response.data.chatmessage, ...messages]);
          } else {
            if (isChatListIDChanged) {
              // Clear messages if selected chat is changed
              setMessages(response.data.chatmessage);
            } else {
              setMessages([...messages, ...response.data.chatmessage]);
            }

            setCurrentPage(page + 1);
          } */

          setMessages(response.data.chatmessage);

          // setPagesID(response.data.conversation[0].PagesID);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });
  };

  const separator = (index, date, otherDate) => {
    if (
      index.toString() === "dateseparator" ||
      index.toString() === "datefloat"
    ) {
      let text = date;
      if (date === moment.utc().format("DD MMM YYYY")) text = "Today";
      else if (date === moment.utc().add(-1, "d").format("DD MMM YYYY"))
        text = "Yesterday";
      return date === otherDate ? (
        ""
      ) : (
        <div
          className={
            index.toString() === "dateseparator" ? "DateSeparator" : "DateFloat"
          }
        >
          <span>{text}</span>
          <span className="DateSeparatorVal" style={{ display: "none" }}>
            {date}
          </span>
        </div>
      );
    }
  };

  const statusSender = (status) => {
    let icon;

    switch (status) {
      case "sent":
        icon = "bi:check";
        break;

      case "NEW":
        icon = "mingcute:time-fill";
        break;

      case "delivered":
      case "read":
        icon = "bi:check-all";
        break;

      default:
        break;
    }

    return (
      <span className="message-status">
        {status === "failed" ? (
          "Failed"
        ) : (
          <Icon
            color={status === "read" ? "#0343C7" : "#727272"}
            height="18"
            icon={icon}
          />
        )}
      </span>
    );
  };

  function renderHandoverSeparator(currentMessage, messages, currentIndex) {
    // don't show separator if current message is from customer
    if (!currentMessage?.IsAgent) {
      return null;
    }

    // Find the previous agent message
    let previousAgentMessage = null;

    for (let i = currentIndex + 1; i < messages.length; i++) {
      if (messages[i].IsAgent) {
        previousAgentMessage = messages[i];
        break;
      }
    }

    // Show chat room ID on start
    if (!previousAgentMessage) {
      return (
        <div className="handover-separator">
          <hr />

          <p>
            ChatRoom #FB{chatListID} with{" "}
            {currentMessage.AgentName ?? "Operator"}
          </p>

          <hr />
        </div>
      );
    } else if (
      // Show separator if agent changed
      previousAgentMessage?.AgentName !== currentMessage?.AgentName &&
      currentMessage?.Type !== "template"
    ) {
      return (
        <div className="handover-separator">
          <hr />

          <p>
            Handover to {currentMessage.AgentName ?? "Operator"} at{" "}
            {moment.utc(currentMessage.CreatedTime).format("HH:mm")}
          </p>

          <hr />
        </div>
      );
    }

    return null;
  }

  return (
    <div className="message-list">
      <ModalMedia
        mediaURL={selectedMediaURL}
        open={isModalMediaOpen}
        source="FBCHAT"
        type={selectedMediaType}
        onClose={() => {
          setSelectedMediaURL("");
          setIsModalMediaOpen(false);
        }}
      />

      {isLoading ? (
        <Loader />
      ) : (
        <div className="message-list-content">
          {separator(
            "datefloat",
            moment.utc(getDate).format("DD MMM YYYY"),
            moment.utc(getDate).add(1, "d").format("DD MMM YYYY")
          )}

          <div
            className="infinite-scroll-target"
            id="messageListInfiniteScrollTarget"
          >
            <InfiniteScroll
              dataLength={messages.length}
              // hasMore={hasMore}
              inverse
              // loader={<Loader />}
              // next={() => fetchMessageListFB(currentPage)}
              scrollableTarget="messageListInfiniteScrollTarget"
              scrollThreshold={0.95}
              style={{ display: "flex", flexDirection: "column-reverse" }}
            >
              {/* Reverse list */}
              {messages.map((message, index, array) => {
                return (
                  <Fragment key={message.MessageID}>
                    <div>
                      <div
                        className={`message-bubble-container
                          ${message.IsAgent ? "agent" : "customer"}
                        `}
                      >
                        <div className="message-bubble">
                          {message.IsAgent && (
                            <span className="sender-name">
                              {message.AgentName}
                            </span>
                          )}

                          {renderMessageFB(
                            message.AttachmentName,
                            message.Description,
                            message.MimeType,
                            message.FileURL,
                            setIsModalMediaOpen,
                            setSelectedMediaType,
                            setSelectedMediaURL
                          )}

                          <div className="message-info">
                            <span className="message-time">
                              {moment.utc(message.CreatedTime).format("HH:mm")}
                            </span>

                            {message.IsAgent
                              ? statusSender(message.Status)
                              : ""}
                          </div>
                        </div>
                      </div>
                    </div>

                    {renderHandoverSeparator(message, array, index)}

                    {separator(
                      "dateseparator",
                      moment.utc(message.CreatedTime).format("DD MMM YYYY"),
                      index >= messages.length - 1
                        ? moment
                            .utc(message.CreatedTime)
                            .add(-1, "d")
                            .format("DD MMM YYYY")
                        : moment
                            .utc(array[index + 1].CreatedTime)
                            .format("DD MMM YYYY")
                    )}
                  </Fragment>
                );
              })}
            </InfiniteScroll>
          </div>
        </div>
      )}
    </div>
  );
}

export default MessageListFB;
